import { InboxTypeState } from "./inbox-type-state";
import { Contact, ContactAddress, Purchase } from "@/models/base";
import { AWSFileService, BookYearService, SupplierService } from "@/services";
import { getContactServiceByGroupId } from "../services/contact-services";
import Vue from "vue";
import { InboxreaderService, InboxReaderType } from "@/services/inboxreader-service";
import { IInboxDocumentInfo } from "@/utils/purchase/inboxreader-document-info";



// parseInfoDate reads a dd/mm/yyyy date of the document info.
function parseInfoDate(value:string):Date | null {
	if (!value) return null;
	const parts = value.split("/");
	if (parts.length != 3) return null;
	const day = parseInt(parts[0], 10);
	const month = parseInt(parts[1], 10) - 1; // maanden zijn 0-gebaseerd
	const year = parseInt(parts[2], 10);
	if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
	return new Date(year, month, day);
}

export class InboxTypeStateInbox extends InboxTypeState {
	protected getInboxTypes():InboxReaderType[]{
		return ["inbox"];
	}

	public constructor(vue:Vue){
		super(vue);
	}

	async fetch(processed:boolean, search:string = "", labelIds:number[] = []){
		await super.fetch(processed, search, labelIds);
		if (processed || search || labelIds.length) return;
		this.unprocessedCount = await InboxreaderService.fetchCountFiles(this.getFetchOptions(processed,search, labelIds));
	}

	// eslint-disable-next-line max-lines-per-function
	public async createPurchase():Promise<Purchase>{
		let purchases = this.selection;
		let p = new Purchase();
		p.InboxreaderPurchaseID = purchases[0].ID;
		p.BookYear = BookYearService.selectedBookYear;
		p.JournalID = 1;
		let supplierAiResult = [] as IInboxDocumentInfo[];
		let dueDateFound = false;
		for (let purchase of purchases) {
			for (let file of purchase.Files) {
				p.InboxreaderPurchaseMessageIDs.push(file.ID);
				let ai = file.getDocumentInfo();
				if (ai != null) {
					if(!p.InvoiceNR){
						p.InvoiceNR = ai.InvoiceNr;
					}
					p.Total = p.Total + (parseFloat(ai.Total) || 0);
					p.TotalOpen = 0;
					//p.TotalOpen = p.TotalOpen + (parseFloat(ai.Total) || 0);
					let invoiceDate = parseInfoDate(ai.Date);
					if (invoiceDate) {
						p.InvoiceDate = invoiceDate;
					}
					let dueDate = parseInfoDate(ai.PayableByDate);
					if (dueDate) {
						p.ExpirationDate = dueDate;
						dueDateFound = true;
					}
					if(ai.PaymentReference){
						if(ai.PaymentReference.includes("+++")){
							p.Ogm = ai.PaymentReference.replace(/\D/g,"");
						}else{
							p.Communication = ai.PaymentReference;
						}
					}
					if(!p.ContactID){
						let contactService = getContactServiceByGroupId(2);
						if (ai.SupplierVAT) {
							supplierAiResult.push(ai);
							let contacts = await contactService.getByVat(ai.SupplierVAT);
							if (contacts.length) {
								p.ContactID = contacts[0].ID;
								p.Contact = contacts[0];
							}
						}
					}
				}
				console.log("File?",file);
				if (file.File) {
					let f = await AWSFileService.fetchFile(file.File.Token, file.File.Name, file.File.ContentType);
					console.log("Load file",f);
					p.UnprocessedFiles.push(f);
				}
			}
		}

		if(!p.ContactID && supplierAiResult){
			let supplier = await this.createSupplier(supplierAiResult[0]);
			if(supplier.ID>0){
				p.ContactID = supplier.ID;
				p.Contact = supplier;
			}
		}
		if (!dueDateFound) {
			p.setExpirationDateFromContact();
		}
		return p;
	}


	public async createSupplier(supplierAiResult:IInboxDocumentInfo): Promise<Contact>{

		if(!supplierAiResult){
			return new Contact();
		}

		let confirm = await this.vue.$wf.confirm(this.vue.$ct("components.winbox.supplier-not-found",{supplier: supplierAiResult.Supplier}),
			this.vue.$ct("common.yes"), this.vue.$ct("common.no"), this.vue.$ct("common.warning"), "warning");
		if (confirm){
			let s = new Contact();
			s.GroupID=2;
			s.Iban="";
			s.MainAddress = new ContactAddress();
			s.MainAddress.IsMainAddress=true;
			s.MainAddress.CompanyName=supplierAiResult.Supplier;
			s.MainAddress.AddressLine1=supplierAiResult.SupplierStreet;
			s.MainAddress.Postal=supplierAiResult.SupplierPostal;
			s.MainAddress.City=supplierAiResult.SupplierCity;
			s.MainAddress.CountryCode=supplierAiResult.SupplierCountryCode;
			s.MainAddress.Phone=supplierAiResult.SupplierPhone;
			s.MainAddress.Email=supplierAiResult.SupplierEmail;
			s.Addresses = [s.MainAddress as ContactAddress];
			s.Vat=supplierAiResult.SupplierVAT;
			let supplier = await SupplierService.postContact(s);
			return supplier;
		}

		return new Contact();

	}
}